import { useOwnerSession } from '../hooks/useOwnerSession.js'
import { BusinessNameForm } from '../components/BusinessNameForm.js'
import { LogoUploader } from '../components/LogoUploader.js'

/**
 * Branding page — business name + logo. That's the whole 4a-1 scope; brand
 * color, contact info, social links, hero images are all deferred.
 */
export function BrandingPage() {
  const { data: me, isLoading } = useOwnerSession()

  if (isLoading || !me) {
    return <p className="owner-loading">Loading…</p>
  }

  return (
    <div>
      <h1>Branding</h1>
      <p className="owner-greeting-sub">
        How your business appears on customers' loyalty passes.
      </p>

      <div className="owner-card">
        <div className="owner-card-title">Business name</div>
        <p className="owner-card-sub">
          Shown on the loyalty pass and across your dashboard.
        </p>
        <BusinessNameForm initialName={me.tenant.name} />
      </div>

      <div className="owner-card">
        <div className="owner-card-title">Logo</div>
        <p className="owner-card-sub">
          A square image used on your loyalty passes.
        </p>
        <LogoUploader
          currentLogoUrl={me.tenant.logo_url}
          defaultLogoUrl={me.default_logo_url}
          logoUpdatedAt={me.tenant.logo_updated_at}
        />
      </div>

    </div>
  )
}
